<template>
    <div class="form">
        <Form ref="info" :label-width="110" :rules="ruleValidate">
            <Row :gutter="20">
              <Col span="20">
                <FormItem prop="tplName" label="模板名称">
                  <Input v-model="info.tplName" placeholder="请输入模板名称">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="rentOverduePunish" label="逾期罚款比例">
                        <input-number
                            v-model="info.rentOverduePunish"
                            placeholder
                            :allow-decimal="false"
                            :min="0"
                            :max="100"
                        >
                            <span slot="append">%</span>
                        </input-number>
                    </FormItem>
                </Col>
                <Col>
                  <FormItem label="是否默认" prop="isDefault">
                    <i-switch
                      v-model="info.isDefault"
                      size="large"
                      :true-value="1"
                      :false-value="0"
                    >
                      <span slot="open">是</span>
                      <span slot="close">否</span>
                    </i-switch>
                  </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>

<script>
import { contractTplView, updateRentOverduePunish } from '@/api/configuration'
import mForm from '_v/common/m-form'

export default {
    name: 's-tpl-form',
    mixins: [mForm],
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
    },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            info: {
                id: '',
                rentOverduePunish: 0, // 罚款比例
                isDefault: 0,
                tplName: '',
                ver: '',
            },
        }
    },
    methods: {
        fetch() {
            if (this.id) {
                return contractTplView(this.id)
            } else {
                return Promise.resolve()
            }
        },
    },
    computed: {
        ruleValidate() {
            return {
                rentOverduePunish: [
                    { required: true, message: '逾期罚款比例必填' },
                ],
            }
        },
    },
    mounted() {
        // 按钮配置
        var btns = [{ type: 'default', text: '取消', name: 'cancel' }]

        if (this.$can('update')) {
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([this.fetch()])
                .then((args) => {
                    const [view] = args

                    if (view) {
                        var entity = view.data.entity
                        Object.keys(this.info).forEach((k) => {
                            if (typeof entity[k] !== 'undefined') {
                                this.info[k] = entity[k]
                            }
                        })
                    }

                    this.info.rentOverduePunish *= 100
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            this.$refs.info
                .validate()
                .then(() => {
                    var formData = Object.assign({}, this.info)
                    formData.rentOverduePunish =
                        formData.rentOverduePunish / 100
                    return updateRentOverduePunish(formData)
                })
                .then((res) => {
                    this.$Message.success('设置成功')
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>

<style lang="less" scoped>
.title {
    font-size: 16px;
    padding-left: 10px;
}
</style>
